/**
 * Adobe audience manager integration
 * @module
 */

var _ = require('optimizely-client-fn');
var Cookie = require('core/utils/cookie');




var VENDOR = 'adobe_audience_manager';

/**
 * Per our Adobe Audience Manager implementation instructions,
 * we require that the customer names their cookie 'aamoptsegs'.
 * No other cookie name is supported.
 */
var COOKIE_NAME = 'aamoptsegs';

/**
 * Per the implementation of the Adobe Audience Manager integration,
 * the visitor profile key that the matching segment IDs is 'aamsegments'.
 * No other key is supported.
 */
var VISITOR_PROFILE_KEY = 'aamsegments';

/**
 * Parse the cookie string for matching Adobe Audience Manager segments.
 *    - The cookie format is a comma separated list of key/value pairs (separated by an equal sign).
 *    - The values of the key/value pairs are the matching Adobe Audience Manager segments
 *    - The keys in the key/value pairs are ignored
 *    - Example: "abc=123,def=456" corresponds to matching segments: ["123", "456"]
 *
 * @param {string} [cookieString]
 * @return {Array<string>}
 */
var parseCookieValueForSegments = function(cookieString?:string): string[] {
  if (!cookieString) {
    return [];
  }

  return _.chain(cookieString)
    .split(',')
    .map(function (keyValuePair) {
      return keyValuePair.split('=')[1];
    })
    .filter()
    .value();
};

var pluginAudienceAdobe:AudiencePluginConfig = {
  provider: {
    getter: [
      /**
       * This will return undefined if no Adobe Audience Manager segments are found
       * or an a visitor profile with the matching segments.
       */
      function() {
        var visitorProfile;
        var segments = parseCookieValueForSegments(Cookie.get(COOKIE_NAME));

        if (segments.length) {
          visitorProfile = {} as any;
          visitorProfile[VISITOR_PROFILE_KEY] = segments;
        }

        return visitorProfile;
      }
    ]
  },
  matcher: require('core/plugins/matchers/key_value'),
  vendor: VENDOR,
};

module.exports = function(PluginManager) {
  PluginManager.registerAudiencePlugin(pluginAudienceAdobe);
};

if (__TEST__) {
  module.exports.plugin = pluginAudienceAdobe;
  module.exports.parseCookieValueForSegments = parseCookieValueForSegments;
  module.exports.COOKIE_NAME = COOKIE_NAME;
  module.exports.VISITOR_PROFILE_KEY = VISITOR_PROFILE_KEY;
}
